export default __webpack_public_path__ + "static/media/single-project-page-02-img1.b226f6fc.jpg";